export const HOMEPAGE_SUB_ROUTES = [
  {
    title: 'Home',
    url: '/',
    icon: 'IconHome'
  },
  {
    title: 'Brand Kit',
    url: '/brand-kit',
    hideWhenNewHomepage: true,
    icon: 'IconSparkles'
  }
];
